import Cookie from 'cookie-universal'
import appConstants from '~/libs/constants/application-constants.js'
import { getCookieDomain } from '~/libs/cookie-domain.js'

const { nuxtBaseUrl } = appConstants

/**
 * One-time cookie path migration from '/' to '/bp/'.
 *
 * When the app moved from baseURL '/' to '/bp/', cookies set at path '/' became
 * invisible to code reading at path '/bp/'. This plugin reads known cookies at the
 * old root path, re-writes them at the new '/bp/' path, and deletes the originals.
 *
 * Safe to remove once all user sessions have rotated (~14 days after deploy).
 */
export default defineNuxtPlugin(() => {
  const newPath = `${nuxtBaseUrl}/`
  const cookieDomain = getCookieDomain(useRuntimeConfig())

  // Cookies that were previously set at path '/' and now need to be at '/bp/'
  const cookiesToMigrate = [
    'token',
    'accessToken',
    'borrowerId',
    'isEmbedded',
    'style_id',
    'intercom_hash',
    'anonymousId',
    'redirect',
    'cobrand',
    'affiliate',
    'capturepage',
  ]

  // Embedded cookies that moved from '/embedded' to '/bp/embedded'
  const embeddedCookiesToMigrate = [
    'borrowerId',
    'isEmbedded',
    'style_id',
    'token',
    'embeddedResubmissionEnabled',
  ]

  try {
    const cookies = Cookie()

    for (const name of cookiesToMigrate) {
      const value = cookies.get(name)
      if (value !== undefined && value !== null) {
        // Write to new path
        cookies.set(name, value, { path: newPath, domain: cookieDomain, expires: new Date(Date.now() + 12 * 60 * 60 * 1000) })
        // Remove from old root path
        cookies.remove(name, { path: '/', domain: cookieDomain })
        cookies.remove(name, { path: '/' })
      }
    }

    for (const name of embeddedCookiesToMigrate) {
      const value = cookies.get(name)
      if (value !== undefined && value !== null) {
        cookies.set(name, value, { path: `${newPath}embedded`, domain: cookieDomain, expires: new Date(Date.now() + 12 * 60 * 60 * 1000) })
        cookies.remove(name, { path: '/embedded', domain: cookieDomain })
        cookies.remove(name, { path: '/embedded' })
      }
    }
  } catch (e) {
    // Migration is best-effort — don't break app startup
    console.warn('Cookie path migration failed:', e)
  }
})
